import type { FinanceScope } from '../api/financeTypes'

let last: { token: string | null; scope: FinanceScope } | null = null

export function readScopeCache(token: string | null): FinanceScope | null {
  return last && last.token === token ? last.scope : null
}

export function writeScopeCache(token: string | null, scope: FinanceScope): void {
  last = { token, scope }
}

export function clearScopeCache(): void {
  last = null
}
